import { AbstractControl, FormGroup } from '@angular/forms';

function waitForControlValidation(
  control: AbstractControl,
  timeoutMs = 15_000
): Promise<void> {
  if (control.status !== 'PENDING') {
    return Promise.resolve();
  }

  return new Promise((resolve) => {
    const timeoutId = setTimeout(() => {
      sub.unsubscribe();
      resolve();
    }, timeoutMs);

    const sub = control.statusChanges.subscribe((status) => {
      if (status !== 'PENDING') {
        clearTimeout(timeoutId);
        sub.unsubscribe();
        resolve();
      }
    });
  });
}

/** Espera a que terminen validadores sync/async antes de evaluar el formulario. */
export async function waitForFormValidation(form: FormGroup): Promise<void> {
  form.updateValueAndValidity();

  if (form.status === 'PENDING') {
    await waitForControlValidation(form);
  }

  const controls = Object.values(form.controls);
  const pending = controls.filter((control) => control.status === 'PENDING');
  await Promise.all(pending.map((control) => waitForControlValidation(control)));

  form.updateValueAndValidity({ emitEvent: false });
}
